import React, {useState, useEffect, useRef} from "react";
import Menu from "../../../../components/layout/menu/index";
import buyers from "../../../../assets/images/icons/buyers/buyers.svg"
import buyersList from "../../../../assets/images/icons/buyers/buyersList.svg"
import borderBuyers from "../../../../assets/images/icons/buyers/border-buyers.svg"
import BuyerCard from "../../../../components/card/buyerCard";
import 'simplebar-react/dist/simplebar.min.css';
import { getBuyersChart, getBuyersList} from "../../../../client/buyers/index"
import { useLocation} from "react-router-dom";
import DynamicTable from "../../../../components/tables/oc/provider/dynamicTable"
import { getAreaPerPosition } from "../../../../client/purchaseOrder";
import FilterSelect from "../../../../components/filters/filterSelect";
import { getAreasList} from "../../../../client/areas/index";
import '../../../../../src/index.css'
import { useModuleAdherence } from "../../../../hooks/userAdherence";
export default function Buyers() {
  useModuleAdherence(6);

  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const toggleMenu = () => setIsMenuOpen(!isMenuOpen);

  const [chartData, setChartData] = useState({ users: [], areas: [] });
  const [buyersListData, setBuyersListData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [loadingList, setLoadingList] = useState(true);
  const [error, setError] = useState(null);
  const [errorList, setErrorList] = useState(null);
  const [areas, setAreas] = useState([]); 
  const [selectedArea, setSelectedArea] = useState(null);

  const location = useLocation();

  const [activeSection, setActiveSection] = useState('buyers');
  const showBuyersSection = () => setActiveSection('buyers');
  const showBuyersListSection = () => setActiveSection('buyersList');  
  const positionId=location.state?.positionId;

  const [currentPage, setCurrentPage] = useState(1);
  const [recordsPerPage, setRecordsPerPage] = useState(10);

  const [scrollPosition, setScrollPosition] = useState(0);
  const containerRef = useRef(null);
  const topScrollRef = useRef(null);
const hasScrolledToCenterRef = useRef(false);
const hasScrolledToAreaRef = useRef(false);
  const handleScroll = (e) => {
    const container = e.target;
    setScrollPosition(container.scrollLeft);
    if (topScrollRef.current) {
      topScrollRef.current.scrollLeft = container.scrollLeft;
    }
  };

  const handleTopScroll = (e) => {
    const topScroll = e.target;
    if (containerRef.current) {
      containerRef.current.scrollLeft = topScroll.scrollLeft;
    }
  };

  const changePage = (page) => {
    setCurrentPage(page);
  };

  const columnRefs = useRef({});


useEffect(() => {
  if (location.state?.shouldScroll && chartData.areas.length > 0) {
    if (hasScrolledToAreaRef.current) return;
    
    const areaId = location.state.areaId;

    const timer = setTimeout(() => {
      const targetArea = chartData.areas.find(area => area.id === parseInt(areaId));
      
      if (targetArea) {
        const columnElement = columnRefs.current[targetArea.x_position];
        
        if (columnElement) {
          const container = document.querySelector('.organigrama-container');

          if (container) {
            const containerRect = container.getBoundingClientRect();
            const elementRect = columnElement.getBoundingClientRect();
            
            const scrollLeft = elementRect.left - containerRect.left + container.scrollLeft - (container.offsetWidth / 3);
            
            container.scrollLeft = Math.max(0, scrollLeft);
            
            const topScroll = document.querySelector('.organigrama-container-top');
            if (topScroll) {
              setTimeout(() => {
                topScroll.scrollLeft = container.scrollLeft;
              }, 50);
            }
          }
          
          const elementPosition = columnElement.getBoundingClientRect().top;
          const offsetPosition = elementPosition + window.pageYOffset - 80;

          window.scrollTo({
            top: offsetPosition,
            behavior: "smooth"
          });
          
          hasScrolledToAreaRef.current = true;
        }
      } else {
        const container = document.querySelector('.organigrama-container');
        if (container) {
          requestAnimationFrame(() => {
            const centerScroll = (container.scrollWidth - container.clientWidth) / 2;
            container.scrollLeft = Math.max(0, centerScroll);
            
            const topScroll = document.querySelector('.organigrama-container-top');
            if (topScroll) {
              setTimeout(() => {
                topScroll.scrollLeft = container.scrollLeft;
              }, 50);
            }
            
            const organigramaTop = container.getBoundingClientRect().top;
            const offsetPosition = organigramaTop + window.pageYOffset - 180;
            
            window.scrollTo({
              top: offsetPosition,
              behavior: "smooth"
            });
          });
        }
        hasScrolledToCenterRef.current = true;
      }

    }, 800);

    return () => clearTimeout(timer);
  } 
  
  else if (chartData.areas.length > 0 && activeSection === 'buyers' && !location.state?.shouldScroll) {
    if (hasScrolledToCenterRef.current) return;
    
    const timer = setTimeout(() => {
      const container = document.querySelector('.organigrama-container');
      if (container) {
        requestAnimationFrame(() => {
          const centerScroll = (container.scrollWidth - container.clientWidth) / 2;
          container.scrollLeft = Math.max(0, centerScroll);
          
          const topScroll = document.querySelector('.organigrama-container-top');
          if (topScroll) {
            setTimeout(() => {
              topScroll.scrollLeft = container.scrollLeft;
            }, 50);
          }
          
          const organigramaTop = container.getBoundingClientRect().top;
          const offsetPosition = organigramaTop + window.pageYOffset - 180;
          
          window.scrollTo({
            top: offsetPosition,
            behavior: "smooth"
          });
          
          hasScrolledToCenterRef.current = true;
        });
      }
    }, 600);

    return () => clearTimeout(timer);
  }
}, [location.state, chartData.areas, activeSection]);

useEffect(() => {
  if (activeSection !== 'buyers') {
    hasScrolledToCenterRef.current = false;
    hasScrolledToAreaRef.current = false;
  }
}, [activeSection]);

useEffect(() => {
  return () => {
    hasScrolledToCenterRef.current = false;
    hasScrolledToAreaRef.current = false;
  };
}, []);

  const fetchAreas = async () => {
    try {
      const response = await getAreasList();
      setAreas(response.data);
    } catch (err) {
      console.error("Error al obtener las áreas:", err);
    }
  };

  const fetchChartData = async () => {
    try {
      setLoading(true);
      setError(null);
      
      if (positionId) {
        try {
          const areaResponse = await getAreaPerPosition(parseInt(positionId));
          if (!areaResponse.data?.area?.id) {
            throw new Error('No se encontró el área para esta posición');
          }
          
          const response = await getBuyersChart(areaResponse.data.area.id);
          if (!response.data?.users || !response.data?.areas) {
            throw new Error('Datos del organigrama incompletos');
          }
          const filteredUsers = response.data.users.filter(user => user.record_visibility);
          setChartData({...response.data, users: filteredUsers});
        } catch (err) {
          console.error("Error al obtener datos del organigrama:", err);
          setError(err.message || 'Error al cargar los datos del organigrama');
        }
      } else {
        const response = await getBuyersChart();
        if (!response.data?.users || !response.data?.areas) {
          throw new Error('Datos del organigrama incompletos');
        }
        const filteredUsers = response.data.users.filter(user => user.record_visibility);
        setChartData({...response.data, users: filteredUsers});
      }
    } catch (err) {
      console.error("Error general:", err);
      setError(err.message || 'Error al cargar los datos');
    } finally {
      setLoading(false);
    }
  };

  const fetchBuyersList = async (areaId = null) => {
    try {
      setLoadingList(true);
      setErrorList(null);
      const response = await getBuyersList(areaId);
      
      if (!response.data) {
        throw new Error('No se recibieron datos de la lista de compradores');
      }

      const visibleBuyers = response.data.userPostions.filter(buyer => {
        const recordVisibility = buyer.user.record_visibility !== false;
        return recordVisibility;
      });
      
      const processedData = visibleBuyers.map((buyer, index) => ({
        id: index + 1, 
        name: buyer.user.name || 'N/A',
        charge: buyer.user.charge || 'N/A',
        category: buyer.area.name || 'N/A',
        email: buyer.user.visibility_email ? buyer.user.email || ' ' : ' ',
        contact_number: buyer.user.visibility_contact_number ? (buyer.user.contact_number ? buyer.user.contact_number.toString() : ' ') : ' ',
        whatsapp: buyer.user.visibility_contact_number && buyer.user.contact_number ? () => handleWhatsAppClick(buyer.user.contact_number) : null,
        userId: buyer.user.id,
        areaId: buyer.area.id
      }));
      
      setBuyersListData(processedData);
    } catch (err) {
      console.error("Error al obtener la lista de compradores:", err);
      setErrorList(err.response?.data?.message || err.message || 'Error al cargar la lista de compradores');
    } finally {
      setLoadingList(false);
    }
  };

  useEffect(() => {
    fetchChartData();
    fetchBuyersList();
    fetchAreas();
  }, [positionId]);

  const handleAreaChange = (areaName) => {
    const selected = areas.find(area => area.name === areaName);
    setSelectedArea(selected);
    setCurrentPage(1);
    fetchBuyersList(selected?.id || null);
  };

  const indexOfLastRecord = currentPage * recordsPerPage;
  const indexOfFirstRecord = indexOfLastRecord - recordsPerPage;
  const currentRecords = buyersListData.slice(indexOfFirstRecord, indexOfLastRecord);


const renderChart = () => {
if (loading) return (
  <div className="flex items-center justify-center w-full h-full py-28">
    <div className="w-12 h-12 border-b-2 rounded-full animate-spin border-blue"></div>
  </div>
);
  if (error) return <div className="text-red-500">{error}</div>;
  if (!chartData.users.length) return <div>No hay datos disponibles para mostrar</div>;

  const usersByColumn = {};
  chartData.users.forEach(user => {
    const col = user.x_position;
    if (!usersByColumn[col]) usersByColumn[col] = {};

    let adjustedY = user.y_position;
    while (usersByColumn[col][adjustedY] && usersByColumn[col][adjustedY].length > 0) {
      adjustedY -= 1; 
    }

    if (!usersByColumn[col][user.y_position]) usersByColumn[col][user.y_position] = [];
    usersByColumn[col][user.y_position].push(user);
  });

  const nonEmptyColumns = chartData.areas.filter(area => {
    const columnUsers = usersByColumn[area.x_position] || {};
    return Object.keys(columnUsers).length > 0;
  });

  if (nonEmptyColumns.length === 0) {
    return <div>No hay compradores disponibles para mostrar</div>;
  }

  
  const allLevels = [...new Set(chartData.users.map(u => u.y_position))].sort((a, b) => b - a);
  
  const topLevels = allLevels.filter(l => l >= -1); 
  const areaLevels = allLevels.filter(l => l <= -2); 
  
  const areaColumns = [...new Set(nonEmptyColumns.map(a => a.x_position))].sort((a, b) => a - b);

  return (
    <div className="relative flex flex-col w-full">
      <div 
        ref={topScrollRef}
        className="w-full overflow-x-auto overflow-y-hidden organigrama-container-top"
        onScroll={handleTopScroll}
      >
        <div 
          className="h-[6px]" 
          style={{ 
            width: containerRef.current ? `${containerRef.current.scrollWidth}px` : '100%',
            minWidth: '100%',
            pointerEvents: 'none'
          }}
        />
      </div>
      <div
        ref={containerRef}
        onScroll={handleScroll}
        className="relative flex flex-col w-full organigrama-container">
        <div className="flex flex-col p-4 pb-24 min-w-max">
          
          {/* Niveles superiores (gerente y subgerente) */}
          {topLevels.map((yLevel) => {
            const usersInLevel = Object.values(usersByColumn)
              .flatMap(col => col[yLevel] || []);
            
            if (usersInLevel.length === 0) return null;
  
            return (
              <div key={yLevel} className="relative flex justify-center w-full">
                <div style={{ width: "342px" }}>
                  {usersInLevel.map(user => (
                    <div key={user.id} className="relative">
                      <BuyerCard
                        name={user.name}
                        position={user.charge}
                        email={user.visibility_email ? user.email : null}
                        borderImage={borderBuyers}
                        showEmail={user.visibility_email}
                        height={yLevel >= -1 ? "h-[210px]" : "h-[310px]"}
                        pt={false}
                        showPhone={user.visibility_contact_number}
                        phoneNumber={user.contact_number}
                        iconImage={user.image}
                        visibility_email={user.visibility_email}
                        visibility_contact_number={user.visibility_contact_number}
                      />
                      {/* Línea de conexión hacia abajo */}
                      {[0, -1].includes(yLevel) && (
                        <div className="flex justify-center">
                          <div className={`bg-blue h-[34px] w-[2px] ${areaColumns.length % 2 === 0 && 'ml-[2px]'}`}></div>
                        </div>
                      )}
                      
                    </div>
                  ))}
                </div>
              </div>
            );
          })}
  
          {/* Columnas de área */}
          <div className="flex justify-center w-full">
            {areaColumns.map((col, colIndex) => {
              const area = chartData.areas.find(a => a.x_position === col);
              const columnLevels = areaLevels.filter(l => usersByColumn[col]?.[l]);
              const hasHighlight = area?.id === parseInt(location.state?.areaId);
              const isLastColumn = colIndex === areaColumns.length - 1;
  
              return (
                <div
                  key={col}
                  ref={el => { columnRefs.current[col] = el }}
                  className="relative"
                  style={{ width: "342px" }}
                >
                  <div 
                    className={`relative flex flex-col ${
                      hasHighlight ? 
                      'after:content-[""] after:absolute after:-top-3 after:-left-2 after:-right-2 after:-bottom-3 ' +
                      'after:border-2 after:border-red after:rounded-lg after:pointer-events-none ' +
                      'after:z-10 after:animate-pulse after:shadow-[0_0_0_2px_rgba(239,68,68,0.3)]' : ''
                    }`}
                    style={{
                      height: `${columnLevels.length * 310 + (columnLevels.length > 0 ? (columnLevels.length - 1) * 34 : 0)}px`
                    }}
                  >
                    {columnLevels.map((yLevel) => {
                      const usersInCell = usersByColumn[col][yLevel] || [];
                      const isLastInColumn = yLevel === Math.min(...columnLevels);
  
                      const firstVisibleLevel = Math.max(...columnLevels);
                      const shouldShowDivider = yLevel === firstVisibleLevel;
  
  
                      return (
                        <div key={yLevel} className="relative">
                          {/* Línea vertical izquierda */}
                          <div className={`absolute top-0 ${isLastInColumn ? 'h-1/2' : 'h-full'} w-[2px] bg-blue z-0`} />
  
                          {/* Línea horizontal de conexión */}
                          <div className="absolute w-[34px] h-[2px] bg-blue left-0 top-1/2 z-0" />
  
                          {/* Conector superior para y=-2 */}
                          {/** linea al centro */}
                          {shouldShowDivider && (
                            <div className="flex justify-center">
                              <div className="bg-blue h-[34px] w-[2px] z-0"></div>
                            </div>
                          )} 
                          {/** linea a la derecha */}
                          {shouldShowDivider && isLastColumn && (
                            <div className="absolute top-0 right-0 flex justify-end">
                              <div className="bg-blue h-[34px] w-[2px] z-0"></div>
                            </div>
                          )}
  
                          {/* Tarjeta del usuario */}
                          {usersInCell.map(user => (
                            <React.Fragment key={user.id}>
                              <BuyerCard
                                name={user.name}
                                position={user.charge}
                                email={user.visibility_email ? user.email : null}
                                borderImage={borderBuyers}
                                showEmail={user.visibility_email}
                                height="h-[310px]"
                                pt={false}
                                showPhone={user.visibility_contact_number}
                                phoneNumber={user.contact_number}
                                iconImage={user.image}
                                visibility_email={user.visibility_email}
                                visibility_contact_number={user.visibility_contact_number}
                                areaName={user.area_name}
                              />
  
                              {/* Línea divisoria horizontal después de y=-2 */}
                              {shouldShowDivider && (
                                <div 
                                  className="bg-blue absolute top-0 w-full h-[2px] z-0" 
                                />
                              )}
                            </React.Fragment>
                          ))}
                        </div>
                      );
                    })}
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
</div>
  );
};

  const tableConfig = {
    headers: ['#', 'Nombres y Apellidos', 'Cargo', 'Categoría', 'Correo', 'Contacto', 'Whatsapp'],
    accessors: ['id', 'name', 'charge', 'category', 'email', 'contact_number', 'whatsapp'],
    widths: ['50px', '260px', '140px', '140px', '245px', '131px', '122px']
  };

const handleWhatsAppClick = (phoneNumber) => {
  if (!phoneNumber) return;
  
  const cleanedNumber = phoneNumber.toString().replace(/\D/g, '');
  
  if (cleanedNumber.length < 9) {
    console.error('Número de teléfono inválido');
    return;
  }

  const formattedNumber = cleanedNumber.startsWith('51') 
    ? cleanedNumber 
    : `51${cleanedNumber}`;

  const whatsappUrl = `https://wa.me/${formattedNumber}`;
  window.open(whatsappUrl, '_blank');
};


  return (
    <div>
      <Menu isMenuOpen={isMenuOpen} toggleMenu={toggleMenu} className="transition-all duration-300" />
      <div className={`flex-1 pt-[67px] transition-all duration-300 ${isMenuOpen ? "xl:pl-[20.7%] lg:pl-[23.7%] pl-0" : "pl-0"} bg-[#F7F8F9] w-full z-50 min-h-screen`}>
        <div className="pt-6 pb-10 px-[5%] sm:px-[3%]">
<div className="flex flex-col gap-3">
              <div className="flex items-center justify-between pb-4">
                <h1 className="md:text-[32px] text-2xl text-blue font-itcbold">Compradores</h1>
                <div className="flex items-center justify-between gap-8">
                  <button onClick={showBuyersSection}>
                    <img 
                      src={buyers}
                      alt="Compradores"
                      className={activeSection === 'buyers' ? "" : "opacity-30"}
                    />
                 </button>
                 <button onClick={showBuyersListSection}>
                    <img 
                      src={buyersList}
                      alt="Lista"
                      className={activeSection === 'buyersList' ? "" : "opacity-30"}
                    />
                  </button>
                </div>
              </div>
              {/** organigrama */}
              {activeSection === 'buyers' && renderChart()}
  
              {/** TABLA */}
              {activeSection === 'buyersList' && (
                <div>
                  {loadingList ? (
                    <div>Cargando lista de compradores...</div>
                  ) : errorList ? (
                    <div className="text-red-500">{errorList}</div>
                  ) : (
                    <>  
                      <div className="flex flex-col gap-3">
                        <div className="flex flex-col gap-1">
                          <p className="font-itcbook text-[15px]">Categoría</p>
                          <FilterSelect 
                            text="Escoja su categoría"
                            options={areas.map(area => area.name)}
                            onSelect={handleAreaChange}
                            selectedOption={selectedArea?.name}
                          />
                        </div>
                        {buyersListData.length > 0 ? (
                          <DynamicTable
                            data={currentRecords}
                            config={tableConfig}
                            showRadioButtons={false}
                            showPagination={true}
                            currentPage={currentPage}
                            totalPages={Math.ceil(buyersListData.length / recordsPerPage)}
                            changePage={changePage}
                            recordsPerPage={recordsPerPage}
                            totalRecords={buyersListData.length}
                          />
                        ) : (
                          <div className="py-4 text-center font-itcbook text-red">
                            {selectedArea && "No hay registros en la categoría seleccionada" }
                          </div>
                        )}
                      </div>
  
                    </>
  
                  )}
                </div>
              )}
</div>
        </div>
      </div>
    </div>
  );
}